<template>
  <div class="noon-form-single-file">
    <div class="aisea-text-12-400-gray">{{ form.label }}</div>
    <div
      v-if="!hasFiles"
      :class="[isDrag ? dragoverClass : dragleaveClass]"
      @dragover.prevent="checkDrag($event, true)"
      @dragleave.prevent="checkDrag($event, false)"
      @drop.prevent="handleFileSelect($event)"
      @click="$refs.update_photo_input.click()"
    >
      <input
        type="file"
        ref="update_photo_input"
        class="hidden"
        @change="handleFileSelect($event)"
      />
      <feather-icon
              svgClasses="h-6 w-6"
              icon="FileIcon"
              class="mb-2"
            ></feather-icon>
      <span
        >ファイルをドロップ、またはクリックして<br>ファイルを選択し、追加
      </span>
    </div>
    <div v-else>
      <div
        v-for="(file, index) in files"
        :key="index"
        class="file-name-label relative p-2"
      >
        <!-- 書類名ラベルエリア -->
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <feather-icon
              svgClasses="h-6 w-6"
              icon="FileIcon"
              class="mr-2"
            ></feather-icon>
            <div v-show="!file.isEditing" class="break-all">
              {{ file.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>

import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    form: { type: Object, required: true },
    value: { required: false }
  },
  data () {
    return {
      inputValue: null,
      files: [],

      dragleaveClass: "drag-area-dragleave",
      dragoverClass: "drag-area-dragover",
      isDrag: false,
      isCrop: null,


    }
  },
  watch: {
    inputValue: {
      handler (val) {
        const payload = {
          id: this.form.id,
          value: val,
          isAlert: this.isAlert
        };
        this.$emit("setValue", payload)
      },
      deep: true,
    },
  },
  computed: {
    isAlert () {
      return false;
    },
    hasFiles () {
      return this.files.length > 0
    },
  },
  methods: {
    handleFileSelect (e) {
      let _files = [];

      if ("files" in e.target) {
        _files = e.target.files;
      } else if ("files" in e.dataTransfer) {
        _files = e.dataTransfer.files;
      }

      _files.forEach((item) => {

        const file = {};

        file.name = item.name;
        file.size = item.size;
        file.type = item.type;

        let reader = new FileReader();
        reader.onload = _e => {
          file.src = _e.target.result;
        };
        reader.readAsDataURL(item);

        this.files.push(file);
      });
    },
  },
  mounted () {
    if (this.value) {
      this.inputValue = this.value;
      return;
    }
    this.inputValue = this.form.default_value;
  }
}
  </script>
  
<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

.noon-form-single-file {
  --vs-primary: 3, 155, 229;

  .drag-area-dragleave {
    width: 100%;
    min-width: 120px;
    height: 100%;
    min-height: 100px;
    border: 2px dotted rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #f5f5f5;
    text-align: center;
  }
  .drag-area-dragover {
    width: 100%;
    min-width: 200px;
    height: 100%;
    min-height: 200px;
    border: 2px solid $aisea-blue;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #f5f5f5;
    text-align: center;
  }
}
</style>
